import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function usePaidFlowNavigationGuard(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return;

    const onBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', onBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, [enabled]);
}

export function useReadingFlowBackGuard(enabled: boolean): void {
  const navigate = useNavigate();

  useEffect(() => {
    if (!enabled) return;

    const guardState = { nyReadingBackGuard: true };
    window.history.pushState(guardState, '', window.location.href);

    const handlePopState = () => {
      const shouldExit = window.confirm('내용은 저장되어 히스토리에서 다시 보실 수 있습니다.');
      if (shouldExit) {
        navigate('/', { replace: true });
        return;
      }
      window.history.pushState(guardState, '', window.location.href);
    };

    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [enabled, navigate]);
}
